import React, { useEffect } from 'react';

import { useExplorerConfig } from 'lib/contexts/ExplorerConfigContext';

/**
 * Dynamically updates the favicon link elements in the document head
 * when admin settings provide a custom favicon URL.
 */
const DynamicFavicon: React.FC = () => {
  const { config } = useExplorerConfig();

  useEffect(() => {
    const faviconUrl = config?.branding?.favicon_url;
    if (!faviconUrl) {
      return;
    }

    // Update all favicon link elements
    const linkElements = document.querySelectorAll<HTMLLinkElement>(
      'link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]',
    );

    linkElements.forEach((link) => {
      link.href = faviconUrl;
    });

    // If no existing favicon links found, create one
    if (linkElements.length === 0) {
      const newLink = document.createElement('link');
      newLink.rel = 'icon';
      newLink.href = faviconUrl;
      document.head.appendChild(newLink);
    }
  }, [ config?.branding?.favicon_url ]);

  return null;
};

export default DynamicFavicon;



